// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2h6t1","ranges":"BmiRanges_ranges__15L2i"};